import * as Yup from 'yup'
import {ErrorForms} from '../../../../../libs/_fri/utils/enums'

/* Configuration File */
//Max size file accepted
export const maxSize: number = 10000000
//File type accepted
export const fileType = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
}

export interface ICreateStep {
  title?: string
  reference: string
  allowMissingUsers: boolean
  file: File | null
}

export const createStepSchema = Yup.object().shape({
  title: Yup.string(),
  reference: Yup.string().required('Referencia es requerido'),
  allowMissingUsers: Yup.mixed<boolean>().required('Campo requerido'),
  file: Yup.string().required('Archivo es requerido').nullable(),
})

export const initsCreateStep: ICreateStep = {
  title: '',
  reference: '',
  allowMissingUsers: false,
  file: null,
}

// Confirm Step
export interface IConfirmStep {
  dateTime: Date
  notificationEmail?: string
}

export const confirmStepSchema = Yup.object().shape({
  dateTime: Yup.date(),
  notificationEmail: Yup.string().email(ErrorForms.InvalidEmail).optional(),
})

export const initsConfirmStep: IConfirmStep = {
  dateTime: new Date(),
  notificationEmail: '',
}
